import { BREAKPOINTS } from '@app/constants/breakpoints';
import { useIsScreenSize } from '@app/utils/hooks';
import { isEmpty } from '@app/utils/isEmpty';
import React from 'react';

import { Popover } from '../Popover';

interface Props {
  src: string;
  title?: string;
}

export const ImageMagnifier = ({ src, title, children }: React.WithChildren<Props>) => {
  const isMobile = useIsScreenSize(BREAKPOINTS.SM);

  if (isEmpty(src)) {
    return <>{children}</>;
  }

  return (
    <Popover
      placement="right-center"
      className="sm:p-1"
      contentHeader={isMobile ? title : undefined}
      content={<img alt="" role="presentation" className="rounded-small sm:max-h-80" src={src} />}
      isContentHoverable={false}
      triggerClassName="max-w-none"
    >
      {children}
    </Popover>
  );
};
